import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addTaskComment } from '../api/tasks';
import { notification } from 'antd';

export function useAddTaskComment(id: string | null, onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (content: string) => {
      if (!id) throw new Error('Task ID is required');
      return addTaskComment(id, content);
    },
    onSuccess: () => {
      notification.success({ message: 'Comment added' });
      void queryClient.invalidateQueries({ queryKey: ['taskItems'] });
      void queryClient.invalidateQueries({ queryKey: ['taskItem', id] });
      onSuccess?.();
    },
    onError: () => {
      notification.error({ message: 'Failed to add comment' });
    },
  });
}
